import { useEffect, useState } from 'react'
import { CIMSBasicFieldProps } from '../../../CIMSBasicFields/types'
import { useFoundCallback } from './useFoundCallback'
import { ReportValue } from '../../types'
import ReportCustomFields from '../../components/ReportCustomFields'

export function useReportCustomFields(
  reportValues?: ReportValue[]
): CIMSBasicFieldProps[] {
  const [fields, setFields] = useState<CIMSBasicFieldProps[]>([])
  const found = useFoundCallback()
  useEffect(() => {
    if (!reportValues) return
    setFields(
      reportValues.map(({ customFieldId, reports, customField }) =>
        found({
          hidden: !reports.length,
          customField,
          customFieldId,
          children: (
            <ReportCustomFields
              customFieldId={customFieldId}
              reports={reports}
            />
          ),
        })
      )
    )
  }, [found, reportValues])
  return fields
}
